import "./qrCode.css";

import Image2 from "../Assets/1-02.png";
import Image20 from "../Assets/1-20.png";
import Image26 from "../Assets/1-26.png";
import { ReactComponent as HomeBTN } from "../Assets/homebtn.svg";
import { ReactComponent as Image8 } from "../Assets/svg/Beauty, Earth and Planet Elements-08.svg";

export const QRCodePage = ({ qrCodeUrl, pdfUrl, onClick }) => {
  return (
    <div className="qr-code-container">
      {/* dotted line */}
      <div className="dashed-line qr-dashed-line">
        <div className="q-head-icon qr-circle-image-1 ">
          <Image8 className="svgIcon " />
        </div>
        <img src={Image2} className="star" alt="star"></img>
      </div>

      {/* qr container */}
      <div className="qr-cont">
        <img src={Image20} className="qr-logo " alt="qrlogo" />
        <div className="qr-holder">
          <img src={qrCodeUrl} className="qr-code" alt="qr code " />
          {pdfUrl && (
            <a
              href={pdfUrl}
              download="BeautyBill.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              Download Your Beauty Bill
            </a>
          )}
        </div>
      </div>

      {/* dotted line */}
      <div className="dashed-line qr-dashed-line">
        <div
          className="q-head-icon qr-circle-image-3 "
          onClick={() => {
            setTimeout(() => {
              onClick();
            }, 500);
          }}
        >
          <HomeBTN className="svgIcon" />
        </div>
      </div>
      <div className="footer-container">
        <img src={Image26} className="page-footer" alt="footer"></img>
      </div>
    </div>
  );
};
